import { render, staticRenderFns } from "./FormularioFinalizadoComponent.vue?vue&type=template&id=05838d84&"
import script from "./FormularioFinalizadoComponent.vue?vue&type=script&lang=ts&"
export * from "./FormularioFinalizadoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports